import { MapPin, Phone, Mail, ArrowUpRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import LeadForm from "@/components/LeadForm";
import SocialButtons from "@/components/SocialButtons";
import { CONTACT } from "@/lib/api";

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <PageHero
        eyebrow="Contact Us — Ahmedabad"
        title={["Let's Discuss", "Your Next Move."]}
        sub="Loans, wealth, insurance, liquidity, marketing, IT or interiors — pick the desk and the conversation starts today."
      />

      <section className="py-16 sm:py-24" data-testid="contact-main-section">
        <div className="container-x grid grid-cols-1 gap-10 lg:grid-cols-12">
          {/* FORM */}
          <Reveal className="lg:col-span-7">
            <div className="rounded-3xl border border-slate-200 bg-white p-6 shadow-xl sm:p-8" data-testid="contact-form-card">
              <h2 className="font-display text-2xl font-extrabold text-navy">Tell us what you need.</h2>
              <p className="mt-2 text-sm text-slate-600">We reply within one working day — usually much sooner.</p>
              <div className="mt-6">
                <LeadForm
                  source="contact-page"
                  fields={["name", "phone", "email", "service", "message"]}
                  cta="Send Message"
                  idPrefix="contact-form"
                />
              </div>
            </div>
          </Reveal>

          {/* INFO */}
          <div className="space-y-5 lg:col-span-5">
            <Reveal delay={0.08}>
              <div className="rounded-3xl border border-slate-200 bg-white p-7" data-testid="contact-info-card">
                <p className="eyebrow">Reach Us</p>
                <div className="mt-5 space-y-4 text-sm text-slate-600">
                  <a
                    href={CONTACT.mapsHref}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex gap-3 transition hover:text-amber-600"
                    data-testid="contact-address-link"
                  >
                    <MapPin className="mt-0.5 h-5 w-5 shrink-0 text-gold-deep" />
                    <span>{CONTACT.address}</span>
                  </a>
                  <a href={CONTACT.phoneHref} className="flex gap-3 font-bold text-navy transition hover:text-amber-600" data-testid="contact-phone-link">
                    <Phone className="h-5 w-5 shrink-0 text-gold-deep" />{CONTACT.phoneDisplay}
                  </a>
                  <a href={`mailto:${CONTACT.email}`} className="flex gap-3 transition hover:text-amber-600" data-testid="contact-email-link">
                    <Mail className="h-5 w-5 shrink-0 text-gold-deep" />{CONTACT.email}
                  </a>
                </div>
                <div className="mt-6 border-t border-slate-100 pt-5">
                  <p className="mb-3 font-mono text-[10px] font-semibold uppercase tracking-[0.25em] text-slate-500">Follow us</p>
                  <SocialButtons />
                </div>
              </div>
            </Reveal>

            <Reveal delay={0.14}>
              <a
                href={`${CONTACT.whatsapp}?text=${encodeURIComponent("Hello Evolve Elite, I'd like to discuss my requirements.")}`}
                target="_blank"
                rel="noopener noreferrer"
                className="card-lift flex items-center justify-between gap-4 rounded-3xl bg-[#25D366] p-7 text-white"
                data-testid="contact-whatsapp-card"
              >
                <div>
                  <p className="font-display text-xl font-extrabold">Chat on WhatsApp</p>
                  <p className="mt-1 text-sm text-white/85">Instant answers during working hours — tap to open.</p>
                </div>
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-white/20">
                  <ArrowUpRight className="h-6 w-6" />
                </span>
              </a>
            </Reveal>

            <Reveal delay={0.2}>
              <div className="grain rounded-3xl bg-navy p-7 text-white" data-testid="contact-assurance-card">
                <p className="eyebrow !text-gold">Our Promise</p>
                <p className="mt-4 text-sm leading-relaxed text-white/75">
                  Every enquiry on this page lands directly with the right specialist desk — no call centre, no lead
                  resale, no spam. Your details belong to Evolve Elite alone.
                </p>
              </div>
            </Reveal>
          </div>
        </div>

      </section>
    </div>
  );
}
